import { i18n } from '@lingui/core';
import { messages } from '../locales/en/messages.js';

i18n.load('en', messages);
i18n.activate('en');

export { i18n };
